<template>
	<div class="rzy-page">
		<div class="rzy-top-bar">
			<div style="display: flex; flex-direction: row; ">
				<div style="width: 20%;line-height: 40px;">入库日期</div>
				<el-date-picker
					style=""
					@change="daterangeSelectChange()"
					v-model="daterangeSelectResult"
					type="daterange"
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
				></el-date-picker>
			</div>
		</div>

		<el-table
			:data="responseData"
			:header-cell-style="{ 'text-align': 'center' }"
			:span-method="objectSpanMethod"
			:cell-style="{ padding: '0px' }"
			border
			stripe
			id="localListTableId"
			@selection-change="handleSelectionChange"
		>
			<el-table-column label="行" type="index" :index="indexMethod" align="center"></el-table-column>

			<el-table-column sortable prop="warehouseName" label="仓库" align="center"></el-table-column>
			<el-table-column sortable prop="positionName" label="仓位" align="center">
				<template slot-scope="scope">
					<el-link type="primary" @click="goToDetails(scope.row.positionId, scope.row.warehouseName, scope.row.positionName)">{{ scope.row.positionName }}</el-link>
				</template>
			</el-table-column>
			<el-table-column sortable prop="materialNumber" label="物料编码" align="center"></el-table-column>
			<el-table-column sortable prop="materialName" label="物料名称" align="center"></el-table-column>
			<el-table-column sortable prop="count" label="数量(匹)" align="center"></el-table-column>
			<el-table-column sortable prop="productLength_change" label="米数(米)" align="center"></el-table-column>
			<el-table-column sortable prop="productWeight_change" label="过磅重量(千克)" align="center"></el-table-column>
		</el-table>

		<el-pagination
			style="text-align: center"
			background
			layout="prev, pager, next"
			@current-change="handleCurrentChange"
			:page-size="pageInfo.size"
			:current-page="pageInfo.page"
			:page-count="totalPages"
		></el-pagination>
	</div>
</template>

<script>
export default {

	data() {
		return {
			firstLevelIndexArr: [], // 一个空的数组，用于存放第一列每一行记录的合并数  控制第一列的合并
			firstLevelIndexPos: 0, // firstLevelIndexArr 的索引
			//分页 -- sta
			pageInfo: {
				page: 1,
				size: 15
			},
			totalPages: 0,
			//分页 -- end


			//日期范围选择控件 -- sta
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},
			daterangeSelectResult: '', //日期范围 选择的结果
			//日期范围选择控件 -- end

			responseData: [
				// 调试用假数据--正式版注释掉
				{
					number: 'XXX'
				}
			]
		};
	},
	methods: {
		//动态合并表格
		getSpanArr(data) {
			// firstLevelIndexArr/secondLevelIndexArr来存放要合并的格数，同时还要设定一个变量firstLevelIndexPos/secondLevelIndexPos来记录
			this.firstLevelIndexArr = [];
			this.secondLevelIndexArr = [];
			this.indexDescArr = [];
			for (var i = 0; i < data.length; i++) {
				if (i === 0) {
					this.firstLevelIndexArr.push(1);
					this.firstLevelIndexPos = 0;
				} else {
					// 判断当前元素与上一个元素是否相同(第1和第2列)
					if (data[i].warehouseId === data[i - 1].warehouseId) {
						this.firstLevelIndexArr[this.firstLevelIndexPos] += 1;
						this.firstLevelIndexArr.push(0);
					} else {
						this.firstLevelIndexArr.push(1);
						this.firstLevelIndexPos = i;
					}
				}
			}
		},
		//按行合并
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1) {
				const _row = this.firstLevelIndexArr[rowIndex];		
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},

		// 在打印当前报表前，拼接title
		initPrint(id) {
			this.utils.printTable(id, `入库单列表`);
		},

		// 分页切换
		handleCurrentChange(newNum) {
			this.getPeiBuList(newNum);
		},

		// 日期范围选择控件，内容改变事件
		daterangeSelectChange() {
			// console.log('daterangeSelectResult=', this.daterangeSelectResult)
			// console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
			// console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

			//开始时间 转 时间戳
			let m_date = new Date(this.daterangeSelectResult[0]);
			let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
			this.pageInfo.startTime = m_time;
			// console.log('startTime=', this.pageInfo.startTime)

			//结束时间 转 时间戳
			m_date = new Date(this.daterangeSelectResult[1]);
			m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
			this.pageInfo.endTime = m_time;
			// console.log('endTime=', this.pageInfo.endTime)

			this.refreshPage();
		},

		// 刷新
		refreshPage() {
			this.getList(1);
			this.$Message.success('刷新成功');
		},

		// 条件查询
		queryBySelect(pageInfo) {
			this.pageInfo = pageInfo;
			this.getList(1);
		},
		// 清空条件查询
		clearQuery(pageInfo) {
			this.pageInfo = pageInfo;
			this.getList(1);
		},

		// 获取XX分页列表
		getList(val) {
			this.pageInfo.page = val;
			this.$requestBase({
				url: 'v1/stock/list',
				method: 'get',
				params: this.pageInfo
			}).then(res => {
				this.responseData = this.formatResponse(res.data.list);
				this.getSpanArr(this.responseData)
				this.totalPages = res.data.pages;
			});
		},
		// 格式化XX列表
		formatResponse(response) {
			response.forEach((item, index) => {
				item.productLength_change = (item.productLength / 100).toFixed(2); //库存

				//解决bug: 过磅重量数值单位应从克 改 千克。
				item.productWeight_change = (item.productWeight / 1000).toFixed(2); //过磅重量
			});
			return response;
		},

		// 路由至XX详情
		goToDetails(id, warehouseName, positionName) {
			// this.$router.push(`positionDetalis/${id}`) //增加参数，删除
			this.$router.push({
				path: `positionDetalis`,
				query: {
					id: id,
					warehouseName: warehouseName, //仓库
					positionName: positionName //仓位
				}
			});
		},
		//给 所有 表格 自动 加行号
		indexMethod(index) {
			return index + 1;
		}
	},
	created() {},
	mounted() {
		this.getList(1);

	}
};
</script>

<style scoped lang="scss"></style>
